import * as colors from '@mui/material/colors';
import {
  Palette,
  PaletteOptions,
  TypeBackground,
  TypeText,
} from '@mui/material/styles/createPalette';

type ColorsType = typeof colors;
declare module '@mui/material/styles/createPalette' {
  //eslint-disable-next-line
  interface Palette extends ColorsType {
    border: {
      default: string;
      gray: string;
    };
    font: {
      primary: string;
      secondary: string;
      disabled: string;
      hint: string;
    };
  }
}

const palette = {
  primary: {
    main: '#114BC2',
    dark: '#153c8d',
    light: '#4F7FE6',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#C28811',
    dark: '#8F640C',
    light: '#E0A93F',
    contrastText: '#ffffff',
  },
  font: {
    primary: '#130f26',
    secondary: '#757575',
    disabled: '#9e9e9e',
    hint: '#aaaaaa',
  },
  border: {
    default: '#e0e0e0',
    gray: '#E8E5E8',
  },
  error: {
    main: '#cc310a',
  },
  warning: {
    main: '#fcb23b',
  },
  info: {
    main: '#fcb23b',
  },
  success: {
    main: '#8abb2a',
  },
  background: {
    default: '#EAECEF',
    paper: '#fafafb',
  },
  ...colors,
};

export default palette;
